// extracted by mini-css-extract-plugin
module.exports = {"condensedMenu":"CondensedMenu_condensedMenu__Ap3bB","condensedMobileMenuOpened":"CondensedMenu_condensedMobileMenuOpened__PsvaA"};